import { Controller } from "@hotwired/stimulus"

// Parcours de triage incident : révèle un seul écran à la fois selon la famille
// choisie puis l'urgence déclarée. Le serveur reste source de vérité ; ce
// contrôleur ne gère que la visibilité et la famille du formulaire de rappel.
export default class extends Controller {
  static targets = ["screen", "familyField"]

  connect() {
    this.family = null
    this.reveal("family", null)
  }

  selectFamily(event) {
    this.family = event.target.value
    this.reveal("reflexes", this.family)
  }

  chooseUrgency(event) {
    if (event.target.value === "urgent") {
      this.familyFieldTargets.forEach((f) => (f.value = this.family))
      this.reveal("urgent", this.family)
    } else {
      this.reveal("durable", this.family)
    }
  }

  back(event) {
    const to = event.params.to // "family" | "reflexes"
    this.reveal(to, to === "family" ? null : this.family)
  }

  reveal(screen, family) {
    this.screenTargets.forEach((el) => {
      const match =
        el.dataset.screen === screen &&
        (!el.dataset.family || el.dataset.family === family)
      el.classList.toggle("hidden", !match)
    })
  }
}
